import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'

import PopupComponent from '../../../components/popup/popup.component'
import { BackgroundContainer, LoginContainer, SideContainer, LogoContainer, LoginFormContainer, RememberContainer, CopyContainer, ErrorContainer } from '../../../pages/login/login.styles'
import HeadingComponent from '../../../components/heading/heading.component'
import LabelComponent from '../../../components/label/label.component'
import InputComponent from '../../../components/input/input.component'
import CheckboxComponent from '../../../components/checkbox/checkbox.component'
import LinkComponent from '../../../components/link/link.component'

import { ListBodyContainer, ListContainer, ListContentContainer } from '../admin.styles'
import '../autocompleter.css';
import { GET_USER_LIST } from '../../../config/graphql'

import autocomplete from 'autocompleter';
import { authHeaders } from '../../../utils/api-auth'

export const PopupCreateDeposit = ({ body, height, width, isOpen, isOpenContainer, evTooglePopup, dataDetail }) => {
  console.log(dataDetail);
  const { loading, data } = useQuery(GET_USER_LIST);
  console.log(data);
  const users = data?.users || [];
  console.log(users);

  useEffect(() => {
    var input = document.getElementById('input-name');
    if (!input) return;

    const instance = autocomplete({
      input: input,
      minLength: 1,
      fetch: function (text, update) {
        text = text.toLowerCase();
        // you can also use AJAX requests instead of preloaded data
        var suggestions = users
          // Students without a classroom (classroom: null) are skipped instead of crashing the list.
          .filter(n => (n.name || '').toLowerCase().includes(text) && ((n.kind == 'murid' && n.classroom?.active) || n.kind == 'guru'))
          .map(function (n) { return { label: `${n.name} (${n.kind == 'murid' ? `Murid Kelas ${n.classroom?.name}` : 'Staff'})`, value: n.id }; });
        update(suggestions);
      },
      onSelect: function (item) {
        input.value = item.label;
        input.setAttribute('data-user-id', item.value);
      },
      click: e => e.fetch(),
      keyup: e => e.fetch()
    });
    // Attach once per user list; remove the previous widget so instances don't stack.
    return () => instance.destroy();
  }, [users]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // pushing deposit
    // console.log($(''))
    // Submit form via jQuery/AJAX
    // $.ajax({
    //     type: 'POST',
    //     url: '/some/url',
    //     data:  {
    //             "user_id": 7,
    //             "amount": 100000,
    //             "type": "payment",
    //             "id": "135-1-238-42",
    //             "pincode": "123456"
    //     }
    // })
    // .done(function(data) {
    //     window.location.reload(false);
    //     self.clearForm()
    // })
    var xhr = new XMLHttpRequest();
    xhr.open("POST", 'https://genios-api.genios.id/cash_transaction', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    Object.entries(authHeaders()).forEach(([name, value]) => xhr.setRequestHeader(name, value));
    xhr.onreadystatechange = function () {
      if (this.readyState != 4) return;

      if (this.status == 200) {
        var data = JSON.parse(this.responseText);

        console.log(data);
        // we get the returned data
      }
      window.location.reload(false);

      // end of state change: it can be after some time (async)
    };

    xhr.send(JSON.stringify({
      "user_id": document.getElementById('input-name').dataset.userId,
      "amount": document.getElementById('input-deposit').value,
      "admin_id": 233,
      "type": "deposit"
    }));
  };
  return (
    <PopupComponent body={body} height={height} width={width} isOpen={isOpen} isOpenContainer={isOpenContainer} evTooglePopup={evTooglePopup}>
      <div aria-label='head'>{dataDetail.length} Deposit</div>
      <div aria-label='body'>
        <LoginFormContainer onSubmit={handleSubmit}>
          <LabelComponent mode="block">
            Nama
          </LabelComponent>
          <InputComponent id='input-name' type="nama" mode="large" name="nama" required />
          <LabelComponent mode="block">
            Deposit
          </LabelComponent>
          <InputComponent id='input-deposit' type="desposit" mode="large" name="desposit" required />
          <RememberContainer>
          </RememberContainer>
          <InputComponent id='button-login' type="submit" mode="large" value="Deposit" />
        </LoginFormContainer>
      </div>
    </PopupComponent>
  );
}
